// import {
//     Box,
//     Container,
//     Typography,
//     TextField,
//     InputAdornment,
//     Paper,
//     Button,
//     Grid,
//     Skeleton,
//     Collapse,
//     Stack
// } from '@mui/material'
// import React, { useEffect, useState, useMemo } from 'react'
// import { useTheme } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import TuneIcon from '@mui/icons-material/Tune';
// import { useTranslation } from 'react-i18next';
// import API from "../config/axios";
// import { api_paths } from '../config/api.paths';
// import ProjectCard from '../components/ProjectCard';
// import ProjectFilters from '../components/ProjectFilters';
// import { useNavigate } from 'react-router-dom';

// const Projects = () => {
//     const { t } = useTranslation();
//     const theme = useTheme();
//     const navigate = useNavigate();

//     const [searchQuery, setSearchQuery] = useState('');
//     const [projects, setProjects] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [filtersOpen, setFiltersOpen] = useState(false);

//     const [activeFilters, setActiveFilters] = useState({
//         category: 'All Categories',
//         technology: 'All Technologies',
//         domain: 'All Domains',
//         country: 'All Countries'
//     });

//     const toggleFilters = () => {
//         setFiltersOpen((prev) => !prev);
//     };

//     const handleFilterChange = (type, value) => {
//         setActiveFilters(prev => ({
//             ...prev,
//             [type]: value
//         }));
//     };

//     const clearAllFilters = () => {
//         setActiveFilters({
//             category: 'All Categories',
//             technology: 'All Technologies',
//             domain: 'All Domains',
//             country: 'All Countries'
//         });

//         setSearchQuery('');
//     };

//     const activeFilterCount = useMemo(() => {
//         let count = 0;
//         if (activeFilters.category !== 'All Categories') count++;
//         if (activeFilters.technology !== 'All Technologies') count++;
//         if (activeFilters.domain !== 'All Domains') count++;
//         if (activeFilters.country !== 'All Countries') count++;
//         return count;
//     }, [activeFilters]);

//     useEffect(() => {
//         const fetchProjects = async () => {
//             try {
//                 const response = await API.get(api_paths.PROJECT.get);
//                 const projectList = response.data?.payload?.data?.projects || [];
//                 setProjects(projectList);
//             } catch (error) {
//                 console.error("Error fetching projects:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchProjects();
//     }, []);

//     const filteredProjects = useMemo(() => {
//         const filtered = projects.filter(project => {
//             const matchesSearch =
//                 project.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 project.technology?.some(tech => tech.toLowerCase().includes(searchQuery.toLowerCase())) ||
//                 project.description?.toLowerCase().includes(searchQuery.toLowerCase());

//             const matchesCategory = activeFilters.category === 'All Categories' ||
//                 project.category?.name === activeFilters.category;

//             const matchesTech = activeFilters.technology === 'All Technologies' ||
//                 project.technology?.includes(activeFilters.technology);

//             const matchesDomain = activeFilters.domain === 'All Domains' ||
//                 project.domain === activeFilters.domain;

//             const matchesCountry = activeFilters.country === 'All Countries' ||
//                 project.country === activeFilters.country;

//             return matchesSearch && matchesCategory && matchesTech && matchesDomain && matchesCountry;
//         });

//         const isFiltering = activeFilters.category !== 'All Categories' ||
//             activeFilters.technology !== 'All Technologies' ||
//             activeFilters.domain !== 'All Domains' ||
//             activeFilters.country !== 'All Countries' ||
//             searchQuery !== '';

//         if (isFiltering) {
//             filtered.sort((a, b) => {
//                 const catA = a.category?.order || 0;
//                 const catB = b.category?.order || 0;
//                 if (catA !== catB) return catA - catB;
//                 return (a.order || 0) - (b.order || 0);
//             });
//         }

//         return filtered;
//     }, [projects, searchQuery, activeFilters]);

//     return (
//         <Box id="projects">
//             {/* Hero Section */}
//             <Box
//                 sx={{
//                     background: theme.palette.custom.projectGradient,
//                     color: theme.palette.common.white,
//                     pt: { xs: 15, md: 18 },
//                     pb: { xs: 8, md: 10 },
//                     position: 'relative',
//                     overflow: 'hidden',
//                 }}
//             >
//                 <Container maxWidth="xl">
//                     <Typography
//                         variant="h3"
//                         component="h1"
//                         fontWeight="bold"
//                         sx={{
//                             mb: 2,
//                             fontSize: { xs: '2.5rem', md: '3.5rem' },
//                             color: theme.palette.common.white
//                         }}
//                     >
//                         {t('pages.projects.headline')}
//                     </Typography>
//                     <Typography
//                         variant='body1'
//                         sx={{
//                             color: 'rgba(255, 255, 255, 0.9)',
//                             maxWidth: '600px',
//                             fontSize: '1.1rem',
//                             lineHeight: 1.6
//                         }}
//                     >
//                         {t('pages.projects.subheadline')}
//                     </Typography>
//                 </Container>
//             </Box>

//             {/* Search and Filters Section */}
//             <Container maxWidth="xl" sx={{ mt: -4, position: 'relative', zIndex: 10 }}>
//                 <Paper
//                     elevation={4}
//                     sx={{
//                         p: 2,
//                         borderRadius: 4,
//                         display: 'flex',
//                         flexDirection: { xs: 'column', sm: 'row' },
//                         gap: 2,
//                         alignItems: 'center',
//                         backgroundColor: theme.palette.background.paper,
//                     }}
//                 >
//                     <TextField
//                         fullWidth
//                         placeholder="Search by name, technology, country, domain..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         variant="outlined"
//                         sx={{
//                             '& .MuiOutlinedInput-root': {
//                                 backgroundColor: 'rgba(0, 0, 0, 0.02)',
//                                 borderRadius: 2,
//                                 borderColor: 'grey.300',
//                                 '& fieldset': { borderColor: 'grey.300' },
//                                 height: '40px',
//                             },
//                             '& .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: 'grey.300',
//                             },
//                             '& .MuiOutlinedInput-root:hover fieldset': {
//                                 borderColor: 'grey.300',
//                             },
//                             '& .MuiOutlinedInput-root.Mui-focused fieldset': {
//                                 borderColor: 'grey.300',
//                             },
//                         }}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon sx={{ color: 'text.secondary' }} />
//                                 </InputAdornment>
//                             ),
//                         }}
//                     />
//                     <Button
//                         variant={filtersOpen ? "contained" : "outlined"}
//                         onClick={toggleFilters}
//                         sx={{
//                             borderRadius: 2,
//                             px: 3,
//                             py: 1,
//                             textTransform: 'none',
//                             borderColor: filtersOpen ? theme.palette.primary.main : 'divider',
//                             color: filtersOpen ? theme.palette.common.white : 'text.primary',
//                             whiteSpace: 'nowrap',
//                             minWidth: 'auto',
//                             '&:hover': {
//                                 borderColor: theme.palette.primary.main,
//                                 backgroundColor: filtersOpen ? theme.palette.primary.dark : 'rgba(0, 0, 0, 0.02)',
//                             },
//                             gap: 1.5
//                         }}
//                     >
//                         <Stack direction="row" spacing={1} alignItems="center">
//                             <TuneIcon sx={{ fontSize: 20 }} />
//                             <Typography
//                                 variant="body2"
//                                 fontWeight={600}
//                                 color={filtersOpen ? theme.palette.common.white : theme.palette.text.primary}
//                             >
//                                 Filters
//                             </Typography>
//                             {activeFilterCount > 0 && (
//                                 <Box
//                                     sx={{
//                                         backgroundColor: filtersOpen ? theme.palette.common.white : theme.palette.primary.main,
//                                         color: filtersOpen ? theme.palette.primary.main : theme.palette.common.white,
//                                         borderRadius: '50%',
//                                         width: 20,
//                                         height: 20,
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         fontSize: '0.75rem',
//                                         fontWeight: 'bold'
//                                     }}
//                                 >
//                                     {activeFilterCount}
//                                 </Box>
//                             )}
//                         </Stack>
//                     </Button>
//                 </Paper>

//                 {/* Filters Menu */}
//                 <Collapse in={filtersOpen}>
//                     <ProjectFilters
//                         activeFilters={activeFilters}
//                         onFilterChange={handleFilterChange}
//                         onClearAll={clearAllFilters}
//                     />
//                 </Collapse>

//                 {/* Results Count */}
//                 <Box sx={{ mt: 4, mb: 3 }}>
//                     <Typography variant="body2" color="text.secondary">
//                         Showing {filteredProjects.length} of {projects.length} projects
//                     </Typography>
//                 </Box>

//                 {/* Project Grid */}
//                 <Grid container spacing={4} sx={{ mb: 10 }}>
//                     {loading ? (
//                         [1, 2, 3, 4, 5, 6].map((item) => (
//                             <Grid item key={item} size={{ xs: 12, sm: 6, md: 4 }}>
//                                 <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '16px', mb: 2 }} />
//                                 <Skeleton variant="text" width="40%" />
//                                 <Skeleton variant="text" height={40} />
//                                 <Skeleton variant="text" width="80%" />
//                             </Grid>
//                         ))
//                     ) : (
//                         filteredProjects.length > 0 ? (
//                             filteredProjects.map((project) => (
//                                 <Grid item key={project._id} size={{ xs: 12, sm: 6, md: 4 }}>
//                                     <ProjectCard
//                                         project={project}
//                                         onViewDetails={() => {
//                                             navigate(`/project/${project._id}`);
//                                         }}
//                                     />
//                                 </Grid>
//                             ))
//                         ) : (
//                             <Grid item size={{ xs: 12 }}>
//                                 <Box sx={{ py: 10, textAlign: 'center' }}>
//                                     <Typography variant="h6" color="text.secondary">
//                                         No projects match your criteria.
//                                     </Typography>
//                                 </Box>
//                             </Grid>
//                         )
//                     )}
//                 </Grid>
//             </Container>
//         </Box>
//     );
// }

// export default Projects;

import {
    Box, Container, Typography, TextField, InputAdornment,
    Paper, Button, Grid, Skeleton, Collapse, Stack, CircularProgress
} from '@mui/material'
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react'
import { useTheme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import { useTranslation } from 'react-i18next';
import API from "../config/axios";
import { api_paths } from '../config/api.paths';
import ProjectCard from '../components/ProjectCard';
import ProjectFilters from '../components/ProjectFilters';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import {
    buildUniqueTechnologies,
} from "../utils/skillNormalization";

const LIMIT = 12;

const Projects = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    // ── Parse filters from URL ──
    const urlCategory = searchParams.get('category');
    const urlTechs = searchParams.getAll('tech');
    const urlDomains = searchParams.getAll('domain');
    const urlCountries = searchParams.getAll('country');
    const urlQuery = searchParams.get('q') || '';

    const [searchQuery, setSearchQuery] = useState(urlQuery);
    const [debouncedSearch, setDebouncedSearch] = useState(urlQuery);
    const [activeFilters, setActiveFilters] = useState({
        category: urlCategory || location.state?.category || 'All Categories',
        technology: urlTechs,
        domain: urlDomains,
        country: urlCountries
    });

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const [categories, setCategories] = useState([]);
    const [allSeenProjects, setAllSeenProjects] = useState([]);
    const [domains, setDomains] = useState([]);
    const [countries, setCountries] = useState([]);

    // ── Update URL whenever state changes ──
    const isFirstRun = useRef(true);
    useEffect(() => {
        // Skip updating URL on the very first mount if the state was already initialized from searchParams
        if (isFirstRun.current) {
            isFirstRun.current = false;
            // However, we might need to set the URL if we came from location.state
            if (!urlCategory && location.state?.category && location.state.category !== 'All Categories') {
                // Keep moving to set the URL below
            } else {
                return; 
            }
        }

        const params = new URLSearchParams();
        if (activeFilters.category !== 'All Categories') params.set('category', activeFilters.category);
        activeFilters.technology.forEach(t => params.append('tech', t));
        activeFilters.domain.forEach(d => params.append('domain', d));
        activeFilters.country.forEach(c => params.append('country', c));
        if (debouncedSearch) params.set('q', debouncedSearch);

        const nextParams = params.toString();
        if (nextParams !== searchParams.toString()) {
            setSearchParams(params, { replace: true });
        }
    }, [activeFilters, debouncedSearch, setSearchParams, searchParams, location.state]);

    // ── Handle external URL changes (e.g. browser back/forward) ──
    useEffect(() => {
        const q = searchParams.get('q') || '';
        if (q !== debouncedSearch) {
            setSearchQuery(q);
            setDebouncedSearch(q);
        }

        const cat = searchParams.get('category') || 'All Categories';
        const techs = searchParams.getAll('tech');
        const doms = searchParams.getAll('domain');
        const counts = searchParams.getAll('country');

        if (cat !== activeFilters.category || 
            JSON.stringify(techs) !== JSON.stringify(activeFilters.technology) ||
            JSON.stringify(doms) !== JSON.stringify(activeFilters.domain) ||
            JSON.stringify(counts) !== JSON.stringify(activeFilters.country)
        ) {
            setActiveFilters({
                category: cat,
                technology: techs,
                domain: doms,
                country: counts
            });
        }
    }, [searchParams]); 

    // ── Debounce search input ──
    const debounceTimer = useRef(null);
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            setDebouncedSearch(value);
            setCurrentPage(1);
            setProjects([]);
        }, 400);
    };

    const toggleFilters = () => setFiltersOpen((prev) => !prev);

    const handleFilterChange = (type, value) => {
        setActiveFilters(prev => ({ ...prev, [type]: value }));
        setCurrentPage(1);
        setProjects([]);
    };

    const clearAllFilters = () => {
        setActiveFilters({
            category: 'All Categories',
            technology: [],
            domain: [],
            country: []
        });
        setSearchQuery('');
        setDebouncedSearch('');
        setCurrentPage(1);
        setProjects([]);
    };

    const activeFilterCount = useMemo(() => {
        let count = 0;
        if (activeFilters.category !== 'All Categories') count++;
        if (activeFilters.technology.length > 0) count++;
        if (activeFilters.domain.length > 0) count++;
        if (activeFilters.country.length > 0) count++;
        return count;
    }, [activeFilters]);

    // Fetch categories on mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await API.get(api_paths.CATEGORY.get);
                const categoryList = response.data?.payload?.data?.categories || [];
                setCategories(categoryList);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, []);

    // Track all seen projects to build dynamic filters
    useEffect(() => {
        if (projects.length > 0) {
            setAllSeenProjects((prev) => {
                const existingIds = new Set(prev.map((p) => p._id));
                const newProjects = projects.filter((p) => p._id && !existingIds.has(p._id));
                if (newProjects.length === 0) return prev;
                return [...prev, ...newProjects];
            });
        }
    }, [projects]);

    const availableTechnologies = useMemo(() => {
        // Map technology to skills for buildUniqueTechnologies utility
        const projectSkills = allSeenProjects.map(p => ({ skills: p.technology }));
        return buildUniqueTechnologies(projectSkills);
    }, [allSeenProjects]);

    // Build dynamic domains and countries from allSeenProjects
    useEffect(() => {
        if (allSeenProjects.length > 0) {
            const uniqueDomains = [...new Set(allSeenProjects.map(p => p.domain).filter(Boolean))].sort();
            const uniqueCountries = [...new Set(allSeenProjects.map(p => p.country).filter(Boolean))].sort();
            setDomains(uniqueDomains);
            setCountries(uniqueCountries);
        }
    }, [allSeenProjects]);

    const fetchProjects = useCallback(async (page = 1, append = false) => {
        try {
            append ? setLoadingMore(true) : setLoading(true);

            const params = {
                limit: LIMIT,
                page,
                isActive: true,
            };

            if (debouncedSearch) params.title = debouncedSearch;
            
            if (activeFilters.category !== 'All Categories') {
                const selectedCat = categories.find(c => c.name === activeFilters.category);
                if (selectedCat) params.category = selectedCat._id;
            }

            // Filter by technology, domain, country (multi-select)
            if (activeFilters.technology.length > 0) params.technology = activeFilters.technology;
            if (activeFilters.domain.length > 0) params.domain = activeFilters.domain;
            if (activeFilters.country.length > 0) params.country = activeFilters.country;

            const response = await API.get(api_paths.PROJECT.get, { params });
            const { projects: newProjects, totalPages: tp, totalResults: tr } = response.data?.payload?.data || {};

            setProjects(prev => append ? [...prev, ...(newProjects || [])] : (newProjects || []));
            setTotalPages(tp || 1);
            setTotalResults(tr || 0);
            setCurrentPage(page);
        } catch (error) {
            console.error("Error fetching projects:", error);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    }, [debouncedSearch, activeFilters, categories]);

    // Re-fetch from page 1 when search or any filter changes
    useEffect(() => {
        fetchProjects(1, false);
    }, [debouncedSearch, activeFilters.category, activeFilters.technology, activeFilters.domain, activeFilters.country, categories]);

    // No client-side filtering needed anymore as we send filters to backend
    const filteredProjects = projects;

    const handleLoadMore = () => {
        fetchProjects(currentPage + 1, true);
    };

    const hasMore = currentPage < totalPages;

    return (
        <Box id="projects">
            {/* Hero Section */}
            <Box
                sx={{
                    background: theme.palette.custom.projectGradient,
                    color: theme.palette.common.white,
                    pt: { xs: 15, md: 18 },
                    pb: { xs: 8, md: 10 },
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Container maxWidth="xl">
                    <Typography
                        variant="h3"
                        component="h1"
                        fontWeight="bold"
                        sx={{
                            mb: 2,
                            fontSize: { xs: '2.5rem', md: '3.5rem' },
                            color: theme.palette.common.white
                        }}
                    >
                        {t('pages.projects.headline')}
                    </Typography>
                    <Typography
                        variant='body1'
                        sx={{
                            color: 'rgba(255, 255, 255, 0.9)',
                            maxWidth: '600px',
                            fontSize: '1.1rem',
                            lineHeight: 1.6
                        }}
                    >
                        {t('pages.projects.subheadline')}
                    </Typography>
                </Container>
            </Box>

            {/* Search and Filters Section */}
            <Container maxWidth="xl" sx={{ mt: -4, position: 'relative', zIndex: 10 }}>
                <Paper
                    elevation={4}
                    sx={{
                        p: 2,
                        borderRadius: 4,
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                        alignItems: 'center',
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <TextField
                        fullWidth
                        placeholder="Search by name, technology..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                borderRadius: 2,
                                height: '40px',
                                '& fieldset': { borderColor: 'grey.300' },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: 'text.secondary' }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        variant={filtersOpen ? "contained" : "outlined"}
                        onClick={toggleFilters}
                        sx={{
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            textTransform: 'none',
                            borderColor: filtersOpen ? theme.palette.primary.main : 'divider',
                            color: filtersOpen ? theme.palette.common.white : 'text.primary',
                            whiteSpace: 'nowrap',
                            minWidth: 'auto',
                            gap: 1.5
                        }}
                    >
                        <Stack direction="row" spacing={1} alignItems="center">
                            <TuneIcon sx={{ fontSize: 20 }} />
                            <Typography variant="body2" fontWeight={600}
                                color={filtersOpen ? theme.palette.common.white : theme.palette.text.primary}>
                                Filters
                            </Typography>
                            {activeFilterCount > 0 && (
                                <Box sx={{
                                    backgroundColor: filtersOpen ? theme.palette.common.white : theme.palette.primary.main,
                                    color: filtersOpen ? theme.palette.primary.main : theme.palette.common.white,
                                    borderRadius: '50%',
                                    width: 20, height: 20,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '0.75rem', fontWeight: 'bold'
                                }}>
                                    {activeFilterCount}
                                </Box>
                            )}
                        </Stack>
                    </Button>
                </Paper>

                <Collapse in={filtersOpen}>
                    <ProjectFilters
                        activeFilters={activeFilters}
                        onFilterChange={handleFilterChange}
                        onClearAll={clearAllFilters}
                        categories={categories}
                        technologies={availableTechnologies}
                        domains={domains}
                        countries={countries}
                    />
                </Collapse>

                <Box sx={{ mt: 4, mb: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        Showing {projects.length} of {totalResults} projects
                    </Typography>
                </Box>

                {/* Project Grid */}
                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {loading ? (
                        [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                            <Grid item key={item} size={{ xs: 12, sm: 6, md: 4 }}>
                                <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '16px', mb: 2 }} />
                                <Skeleton variant="text" width="40%" />
                                <Skeleton variant="text" height={40} />
                                <Skeleton variant="text" width="80%" />
                            </Grid>
                        ))
                    ) : filteredProjects.length > 0 ? (
                        filteredProjects.map((project) => (
                            <Grid item key={project._id} size={{ xs: 12, sm: 6, md: 4 }}>
                                <ProjectCard
                                    project={project}
                                    onViewDetails={() => navigate(`/project/${project._id}`)}
                                />
                            </Grid>
                        ))
                    ) : (
                        <Grid item size={{ xs: 12 }}>
                            <Box sx={{ py: 10, textAlign: 'center' }}>
                                <Typography variant="h6" color="text.secondary">
                                    No projects match your criteria.
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>

                {/* Load More Button */}
                {!loading && hasMore && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 10 }}>
                        <Button
                            variant="outlined"
                            onClick={handleLoadMore}
                            disabled={loadingMore}
                            sx={{
                                backgroundImage: theme.palette.custom.buttonGradient,
                                color: theme.palette.common.white,
                                px: 4,
                                py: 1.5,
                                borderRadius: '10px',
                                textTransform: 'none',
                                fontWeight: 500,
                                minWidth: 160,
                            }}
                        >
                            {loadingMore
                                ? <CircularProgress size={20} sx={{ mr: 1 }} />
                                : null}
                            {loadingMore ? 'Loading...' : 'Load More'}
                        </Button>
                    </Box>
                )}
            </Container>
        </Box>
    );
}

export default Projects;